import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, FormGroup, Input, Label, Modal, Row } from 'reactstrap';
import PropTypes from "prop-types";
import fileDownload from 'js-file-download';
import api from "../../../../services/api";
import Loader from '../../../loaders';
import { TooltipButton } from '../../../inputs';
import moment from 'moment';

export default function JobOrderCandidateMilestoneDocumentListDialog(props) {
    const {jobOrderCandidateIds, onClose} = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const loadData = useCallback(() => {
        if (!jobOrderCandidateIds?.length)
            return;

        setLoading(true);

        api.post("jobordercandidate/milestone/documents", JSON.stringify(jobOrderCandidateIds))
            .then((response) => {
                const grouped = [];
                const map = new Map();

                for (const item of response.data) {
                    const key = `${item.jobOrderCandidateId}##${item.candidateName}`;
                    if (!map.has(key)) {
                        map.set(key, []);
                    }
                    map.get(key).push(item);
                }
                
                for (const [key, milestones] of map.entries()) {
                    const [jobOrderCandidateId, candidateName] = key.split('##');
                    grouped.push({
                        jobOrderCandidateId,
                        candidateName,
                        milestones,
                    });
                }

                setData(grouped);
            })
            .catch((error) => console.error({error}))
            .finally(() => {
                setLoading(false);
            })
        ;
    }, [jobOrderCandidateIds]);

    useEffect(() => {
        if (!jobOrderCandidateIds?.length)
            return;

        loadData();
    }, [jobOrderCandidateIds]);

    const downloadAttachment = (filename, downloadUrl = null) => {
        if (!downloadUrl)
            return;

        setLoading(true);
        let url = downloadUrl;
        api.get(url, { responseType: 'blob' })
        .then(blob => {
            fileDownload(blob.data, filename);
        }).catch(error => {
            console.error(error)
        }).finally(() => setLoading(false))
    }

    return (
        <Modal
            isOpen={true}
            className={'modal-xl'}
            modalClassName="db-example-modal-lg"
        >
        {
            loading && <Loader />
        }
            <div className="modal-header">
                <h5 className="modal-title">Milestone Documents</h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onClose}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                </button>
            </div>
            <div className="modal-body">
                <Container fluid className="px-0">
                    <Row>
                    {
                        data?.map((d, idx) => {
                            return (
                                <Fragment key={`milestone_document_${idx}`}>
                                    <Col>
                                        <Row><Col><h5>#{d.jobOrderCandidateId} - {d.candidateName}</h5></Col></Row>
                                    {
                                        d.milestones?.map((m, m_idx) => {
                                            return (
                                                <Row key={`milestone_document_${idx}_${m_idx}`}>
                                                    <Col xs={3}>{m.milestoneName}</Col>
                                                    <Col xs={2}>{m.milestoneDate ? moment(m.milestoneDate).format("DD.MM.YYYY") : "N/A"}</Col>
                                                    <Col xs={5}>{m.filename}</Col>
                                                    <Col xs={2}>
                                                        <TooltipButton
                                                            id={`download_milestone_document_${m.jobOrderCandidateMilestoneDocumentId}`}
                                                            title="Download Document"
                                                            className="btn-icon"
                                                            color="default"
                                                            size="xsm"
                                                            type="button"
                                                            onClick={() => downloadAttachment(m.filename, `jobordercandidate/milestone/document/${m.jobOrderCandidateMilestoneDocumentId}`)}
                                                        >
                                                            <i className="fas fa-file-download pt-1"></i>
                                                        </TooltipButton>
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }
                                    </Col>
                                </Fragment>
                            )
                        })
                    }
                    </Row>
                </Container>
            </div>
            <div
                className="modal-footer"
            >
                <Button
                    color="secondary"
                    onClick={onClose}
                    type="button"
                >
                    Close
                </Button>
            </div>
        </Modal>
    );
}

JobOrderCandidateMilestoneDocumentListDialog.propTypes = {
    jobOrderCandidateIds: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
}
